import * as Icons from "lucide-react";
import ContactInfo from "@/components/cms/ContactInfo";

function getBlock(page, type) {
  return (
    (page?.sections || [])
      .flatMap((section) => section.blocks || [])
      .find((block) => block.type === type)?.data || {}
  );
}

function Icon({ name, ...rest }) {
  const key = (name || "")
    .split("-")
    .map((w) => w[0]?.toUpperCase() + w.slice(1))
    .join("");

  const C = Icons[key] || Icons.Sparkles;

  return <C {...rest} />;
}

export default function SoftwareContactPage({
  page,
  children,
  done = false,
}) {
  const hero = getBlock(page, "contact_hero");
  const details = getBlock(page, "contact_details");

  const cards = details.items || [];

  return (
    <div data-testid="contact-page">
      <section className="sqit-section">
        <div className="sqit-container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Left */}
            <div>
              <ContactInfo page={page} />
            </div>

            {/* Right */}
            <div className="sqit-card p-8">
              {children}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}